/** タクシー予約画面の緯度経度に関する処理のクラス。 */
export default class Coordinates {
  /** 東京駅の座標（メタ情報を読み込めない時のための本当の初期座標） */
  static readonly TOKYO_STATION = {
    lat: 35.68153260987459,
    lng: 139.76771635598573,
  };
}
